import { render, staticRenderFns } from "./ProofreadingSelectChecksPage.vue?vue&type=template&id=3f585e96"
import script from "./ProofreadingSelectChecksPage.vue?vue&type=script&lang=ts"
export * from "./ProofreadingSelectChecksPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f585e96')) {
      api.createRecord('3f585e96', component.options)
    } else {
      api.reload('3f585e96', component.options)
    }
    module.hot.accept("./ProofreadingSelectChecksPage.vue?vue&type=template&id=3f585e96", function () {
      api.rerender('3f585e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ProofreadingSelectChecksPage.vue"
export default component.exports